module.exports = __webpack_public_path__ + "static/media/honor-inventory-policy-1.74813a16.png";